import hals from '../resources/teasers/HALS_NeurIPS2026_teaser.mp4'
import faml from '../resources/teasers/FAML_CVPR2026_teaser.mp4'
import trajectoryLens from '../resources/teasers/TrajectoryLens_EMNLP2026_teaser.mp4'
import coastSight from '../resources/teasers/CoastSight_teaser.mp4'
import quantum from '../resources/teasers/SPEEDLab_Quantum_Teaser_40s.mp4'

// Teasers shown in the "Selected Research" showcase on the home page.
// To add one: drop the .mp4 in src/resources/teasers, import it above and
// add an entry below. `link` is optional (paper, arXiv or project page).
const teasers = [
  {
    id: 'hals',
    short: 'HALS',
    venue: 'NeurIPS 2026',
    title: 'Do Robust LVLMs Hallucinate More?',
    subtitle:
      'Uncovering robustness-induced hallucination in large vision-language models',
    description:
      'Adversarial robustness is usually treated as a pure win. We examine whether robustly fine-tuned LVLMs pay for it in faithfulness, and characterize the hallucination that robustness training can introduce.',
    tags: ['LVLMs', 'Robustness', 'Hallucination'],
    video: hals,
    link: '',
  },
  {
    id: 'faml',
    short: 'FAML',
    venue: 'CVPR 2026',
    title: 'When Data is Scarce, Learn to Adapt',
    subtitle: 'Robust federated learning via adversarial meta-optimization',
    description:
      'Federated clients often hold only a handful of samples. We combine meta-learning with adversarial optimization so that personalized models adapt quickly while staying robust to attacks.',
    tags: ['Federated Learning', 'Meta-Learning', 'Adversarial'],
    video: faml,
    link: '',
  },
  {
    id: 'trajectory-lens',
    short: 'TrajectoryLens',
    venue: 'EMNLP 2026',
    title: 'Do LVLMs Know When They Are Wrong?',
    subtitle:
      'Trajectory-based correctness estimation from a single forward pass',
    description:
      'We read the trajectory of an LVLM’s internal representations to estimate whether its answer is correct, using only a single forward pass and no repeated sampling.',
    tags: ['LVLMs', 'Uncertainty', 'Interpretability'],
    video: trajectoryLens,
    link: '',
  },
  {
    id: 'coastsight',
    short: 'CoastSight',
    venue: 'FAU VIP Project',
    title: 'CoastSight',
    subtitle: 'Generative and vision-language AI for disaster intelligence',
    description:
      'An interdisciplinary project applying generative AI and vision-language models to disaster intelligence and coastal resilience, with students working hands-on across disciplines.',
    tags: ['Generative AI', 'VLMs', 'Disaster Intelligence'],
    video: coastSight,
    link: '',
  },
  {
    id: 'quantum',
    short: 'Q-Capsule',
    venue: 'Quantum AI',
    title: 'Q-Capsule: A Localized Capsule-Based Quantum Neural Architecture',
    subtitle: 'Trainable. Fault-tolerant. Secure.',
    description:
      'We design quantum models whose gradients survive at scale, test whether entanglement helps attention, and map the attack surfaces across the quantum-AI pipeline so that quantum AI is secure by design.',
    tags: ['Quantum ML', 'Fault Tolerance', 'Security'],
    video: quantum,
    link: '',
  },
]

export default teasers
